const initialState = {
	'navigation': 0,
}

const rerenderReducer = function (state = initialState, action) {
	switch (action.type) {
		case "SET_RERENDER":
			return {
				...state,
				'navigation': state.navigation + 1,
			};
		default:
			return state;
	}
};

export default rerenderReducer